"use client";

import React, { useEffect, useRef, useState } from "react";
import {
  faBoxOpen,
  faBullhorn,
  faCommentDollar,
  faGear,
  faHouse,
  faMagnifyingGlassDollar,
  faStore,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

import { Auth } from "aws-amplify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import classNames from "classnames";
import { getCookie } from "cookies-next";
import { humanize } from "@/utils/utils";
import { usePathname } from "next/navigation";
import { useRouter } from "next/router";

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const router = useRouter();
  const pathname = usePathname();

  const trigger = useRef(null);
  const sidebar = useRef(null);

  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      const user = await Auth.currentAuthenticatedUser();
      const session = await Auth.currentSession();
      const group =
        getCookie("group") ||
        session.getAccessToken().payload["cognito:groups"][0];
      setUser({
        email: user.attributes.email,
        group: humanize(group),
      });
    };
    fetchUser();
  }, []);

  const handleSettingsClick = () => {
    router.push("/settings");
  };

  // close on click outside
  // useEffect(() => {
  //   const clickHandler = ({ target }) => {
  //     if (!sidebar.current || !trigger.current) return;
  //     if (
  //       !sidebarOpen ||
  //       sidebar.current.contains(target) ||
  //       trigger.current.contains(target)
  //     )
  //       return;
  //     setSidebarOpen(false);
  //   };
  //   document.addEventListener("click", clickHandler);
  //   return () => document.removeEventListener("click", clickHandler);
  // });

  // // close if the esc key is pressed
  // useEffect(() => {
  //   const keyHandler = ({ keyCode }) => {
  //     if (!sidebarOpen || keyCode !== 27) return;
  //     setSidebarOpen(false);
  //   };
  //   document.addEventListener("keydown", keyHandler);
  //   return () => document.removeEventListener("keydown", keyHandler);
  // });

  // useEffect(() => {
  //   localStorage.setItem("sidebar-expanded", sidebarExpanded);
  //   if (sidebarExpanded) {
  //     document.querySelector("body").classList.add("sidebar-expanded");
  //   } else {
  //     document.querySelector("body").classList.remove("sidebar-expanded");
  //   }
  // }, [sidebarExpanded]);

  return (
    <div className="">
      {/* Sidebar backdrop (mobile only) */}
      {/* <div
        className={`fixed inset-0 bg-slate-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200 ${
          sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
        aria-hidden="true"
      ></div> */}

      {/* Sidebar */}
      <div
        id="sidebar"
        ref={sidebar}
        className="fixed flex flex-col h-screen p-2 mb-2 overflow-y-auto translate-x-0 bg-white shadow w-52 shrink-0"
      >
        {/* Sidebar header */}
        <div className="flex justify-between">
          {/* Close button */}
          {/* <button
            ref={trigger}
            className="lg:hidden text-slate-500 hover:text-slate-400"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-controls="sidebar"
            aria-expanded={sidebarOpen}
          >
            <span className="sr-only">Close sidebar</span>
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z" />
            </svg>
          </button> */}

          <div className="flex gap-3">
            {sidebarExpanded && <LogoSmall />}
            <h1 className="pt-2 text-2xl font-medium">Optsi</h1>
          </div>
        </div>

        {/* Links */}
        <div className="space-y-8">
          {/* Pages group */}
          <div>
            <ul className="mt-3">
              <DashboardListItem pathname={pathname} />
              <StoreListItem pathname={pathname} />
              <ProductItem pathname={pathname} />
              <ChannelItem pathname={pathname} />
              <MarketingItem pathname={pathname} />
              <CustomerItem pathname={pathname} />
              <AttributionItem pathname={pathname} />
            </ul>
          </div>
        </div>

        <button
          className="flex items-center justify-between p-2 pt-4 mt-auto text-sm text-left border-t hover:text-purple-800"
          onClick={handleSettingsClick}
        >
          <div>
            <div className="font-medium">{user?.group}</div>
            <div className="mt-1 text-xs text-slate-500">{user?.email}</div>
          </div>
          <div className="w-6 text-slate-400">
            <FontAwesomeIcon icon={faGear} className="w-6 h-6" />
          </div>
        </button>

        {/* Expand / collapse button */}
        {/* <div className="justify-end hidden pt-3 mt-auto lg:inline-flex">
          <div className="px-3 py-2">
            <button onClick={() => setSidebarExpanded(!sidebarExpanded)}>
              <span className="sr-only">Expand / collapse sidebar</span>
              <svg
                className="w-6 h-6 fill-current sidebar-expanded:rotate-180"
                viewBox="0 0 24 24"
              >
                <path
                  className="text-slate-400"
                  d="M19.586 11l-5-5L16 4.586 23.414 12 16 19.414 14.586 18l5-5H7v-2z"
                />
                <path className="text-slate-600" d="M3 23H1V1h2z" />
              </svg>
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
}

function LogoSmall() {
  return (
    <Link
      href="/"
      className="mb-2 bg-[#ef0179] p-2 rounded-xl w-12 flex items-center justify-center"
    >
      <svg width="22" height="32" viewBox="0 0 18 26" fill="none">
        <path
          d="M8.42243 12.2049C8.56269 12.2049 8.69474 12.1503 8.79392 12.051C8.8931 11.9516 8.94788 11.8197 8.94788 11.6795V11.3641H8.73778V11.6795C8.73778 11.7638 8.70491 11.8428 8.64544 11.9025C8.58597 11.9622 8.50674 11.9948 8.42243 11.9948C8.33811 11.9948 8.25908 11.962 8.19941 11.9025C8.13975 11.843 8.10708 11.7638 8.10708 11.6795V11.2589C7.97972 11.1628 7.89697 11.0102 7.89697 10.8389V11.6793C7.89697 11.8195 7.95155 11.9516 8.05093 12.0508C8.15011 12.15 8.28216 12.2047 8.42243 12.2047V12.2049Z"
          fill="white"
        />
        <path
          d="M7.89697 10.8213C7.89697 10.818 7.89717 10.8148 7.89736 10.8115C7.89736 10.8148 7.89717 10.818 7.89697 10.8213Z"
          fill="white"
        />
        <path
          d="M9.26284 10.3135H9.18322H8.42204C8.42067 10.3135 8.4193 10.3135 8.41793 10.3135C8.4148 10.3135 8.41186 10.3135 8.40873 10.3135C8.40756 10.3135 8.40638 10.3135 8.40521 10.3135C8.40189 10.3135 8.39856 10.3137 8.39504 10.3139C8.39465 10.3139 8.39406 10.3139 8.39367 10.3139C8.38291 10.3145 8.37215 10.3154 8.36139 10.3166C8.29038 10.3246 8.2225 10.3469 8.16126 10.3821C8.16126 10.3821 8.16126 10.3823 8.16126 10.3825C8.12057 10.4058 8.08341 10.4344 8.05054 10.4672C7.96173 10.5564 7.9046 10.6768 7.89736 10.8104C7.89736 10.811 7.89736 10.8115 7.89736 10.8119C7.89736 10.8153 7.89717 10.8184 7.89697 10.8217C7.89697 10.8229 7.89697 10.8243 7.89697 10.8254C7.89697 10.828 7.89697 10.8307 7.89697 10.8333C7.89697 10.835 7.89697 10.8368 7.89697 10.8387C7.89697 11.0105 7.97972 11.1629 8.10708 11.2589C8.19491 11.3251 8.30407 11.3644 8.42243 11.3644H8.73778H8.94788H9.26323C9.3945 11.3644 9.51833 11.3167 9.61497 11.2294C9.61497 11.2294 9.61516 11.2292 9.61536 11.229C9.61829 11.2265 9.62103 11.2237 9.62377 11.2212C9.62416 11.2208 9.62475 11.2202 9.62514 11.2198C9.62847 11.2167 9.6316 11.2136 9.63473 11.2104C9.63786 11.2073 9.64099 11.204 9.64412 11.2008C9.64451 11.2004 9.64509 11.1999 9.64549 11.1995C9.64822 11.1967 9.65077 11.1938 9.65331 11.1911C9.65331 11.1911 9.65351 11.1909 9.6537 11.1907C9.74095 11.094 9.78868 10.9702 9.78868 10.8389C9.78868 10.7077 9.74095 10.5838 9.6537 10.4872C9.6537 10.4872 9.65351 10.487 9.65331 10.4868C9.65077 10.4839 9.64803 10.4811 9.64549 10.4784C9.64509 10.478 9.64451 10.4774 9.64412 10.477C9.64099 10.4737 9.63786 10.4706 9.63473 10.4674C9.53554 10.3683 9.40349 10.3135 9.26323 10.3135H9.26284ZM9.49681 10.6277C9.49681 10.6277 9.49779 10.6288 9.49837 10.6294C9.5015 10.6329 9.50444 10.6365 9.50737 10.64C9.50737 10.64 9.50737 10.6402 9.50757 10.6404C9.60127 10.7558 9.60127 10.9225 9.50757 11.0377C9.50757 11.0377 9.50737 11.0379 9.50718 11.0381C9.50424 11.0416 9.50131 11.0451 9.49818 11.0486C9.49759 11.0492 9.4972 11.0498 9.49661 11.0504C9.49309 11.0543 9.48938 11.0582 9.48546 11.0621C9.48155 11.0661 9.47783 11.0696 9.47372 11.0733C9.47314 11.0739 9.47255 11.0743 9.47196 11.0749C9.46844 11.078 9.46512 11.0809 9.4614 11.0839C9.4614 11.0839 9.4612 11.0841 9.46101 11.0842C9.40506 11.1298 9.33561 11.1547 9.26225 11.1547H8.9469H8.83442H8.7368H8.42145C8.24773 11.1547 8.10629 11.0132 8.1061 10.8395C8.1061 10.8383 8.1061 10.8372 8.1061 10.836C8.1061 10.8319 8.1061 10.8276 8.10649 10.8235C8.10649 10.8223 8.10649 10.8211 8.10668 10.82C8.10688 10.8157 8.10727 10.8115 8.10766 10.8074C8.10766 10.807 8.10766 10.8067 8.10766 10.8063C8.1151 10.7347 8.14659 10.6681 8.19824 10.6165C8.21565 10.5991 8.23502 10.5838 8.25556 10.5711C8.29507 10.5467 8.33948 10.5312 8.38624 10.5261C8.38682 10.5261 8.38741 10.5261 8.388 10.5259C8.38839 10.5259 8.38878 10.5259 8.38917 10.5259C8.39347 10.5255 8.39778 10.5251 8.40189 10.5249C8.40306 10.5249 8.40404 10.5249 8.40521 10.5248C8.40951 10.5246 8.41401 10.5244 8.41832 10.5244C8.4193 10.5244 8.42027 10.5244 8.42106 10.5244H8.50068H8.84146H9.26167C9.34598 10.5244 9.42501 10.5572 9.48468 10.6167C9.4884 10.6204 9.49211 10.6243 9.49583 10.6284L9.49681 10.6277Z"
          fill="white"
        />
        <path
          d="M9.78382 10.8429V10.7633V10.0021C9.78382 10.0007 9.78382 9.99937 9.78382 9.998C9.78382 9.99487 9.78382 9.99194 9.78382 9.98881C9.78382 9.98764 9.78382 9.98646 9.78382 9.98529C9.78382 9.98196 9.78362 9.97864 9.78343 9.97512C9.78343 9.97473 9.78343 9.97414 9.78343 9.97375C9.78284 9.96299 9.78186 9.95223 9.78069 9.94147C9.77267 9.87046 9.75037 9.80257 9.71515 9.74134C9.71515 9.74134 9.71496 9.74134 9.71476 9.74134C9.69148 9.70065 9.66292 9.66348 9.63005 9.63062C9.54085 9.5418 9.42034 9.48468 9.28673 9.47744C9.28614 9.47744 9.28556 9.47744 9.28516 9.47744C9.28184 9.47744 9.27871 9.47725 9.27538 9.47705C9.27421 9.47705 9.27284 9.47705 9.27167 9.47705C9.26912 9.47705 9.26638 9.47705 9.26384 9.47705C9.26208 9.47705 9.26032 9.47705 9.25836 9.47705H9.25817C9.0868 9.47705 8.93421 9.5598 8.83835 9.68715C8.77223 9.77499 8.73291 9.88415 8.73291 10.0025V10.3179V10.528V10.8433C8.73291 10.9746 8.78064 11.0984 8.86789 11.195C8.86789 11.195 8.86809 11.1952 8.86828 11.1954C8.87083 11.1984 8.87357 11.2011 8.87611 11.2038C8.8765 11.2042 8.87709 11.2048 8.87748 11.2052C8.88061 11.2085 8.88374 11.2117 8.88687 11.2148C8.89 11.2179 8.89332 11.2211 8.89645 11.2242C8.89685 11.2246 8.89743 11.2252 8.89782 11.2256C8.90056 11.2283 8.9035 11.2308 8.90624 11.2334C8.90624 11.2334 8.90643 11.2336 8.90663 11.2338C9.00327 11.321 9.1271 11.3688 9.25836 11.3688C9.38963 11.3688 9.51346 11.321 9.6101 11.2338C9.6101 11.2338 9.6103 11.2336 9.61049 11.2334C9.61343 11.2308 9.61617 11.2281 9.6189 11.2256C9.6193 11.2252 9.61988 11.2246 9.62027 11.2242C9.6236 11.2211 9.62673 11.2179 9.62986 11.2148C9.72904 11.1156 9.78382 10.9836 9.78382 10.8433V10.8429ZM9.46964 11.0769C9.46964 11.0769 9.46847 11.0779 9.46788 11.0785C9.46436 11.0816 9.46084 11.0845 9.45732 11.0875C9.45732 11.0875 9.45712 11.0875 9.45692 11.0876C9.34151 11.1814 9.17483 11.1814 9.05961 11.0876C9.05961 11.0876 9.05941 11.0875 9.05922 11.0873C9.05569 11.0843 9.05217 11.0814 9.04865 11.0783C9.04806 11.0777 9.04748 11.0773 9.04689 11.0767C9.04298 11.0732 9.03907 11.0695 9.03515 11.0655C9.03124 11.0616 9.02772 11.0579 9.024 11.0538C9.02342 11.0532 9.02302 11.0526 9.02244 11.052C9.01931 11.0485 9.01637 11.0452 9.01344 11.0415C9.01344 11.0415 9.01324 11.0413 9.01305 11.0411C8.96747 10.9851 8.94262 10.9157 8.94262 10.8423V10.527V10.4145V10.3169V10.0015C8.94262 9.82781 9.08406 9.68637 9.25778 9.68618C9.25895 9.68618 9.26012 9.68618 9.2613 9.68618C9.26541 9.68618 9.26971 9.68618 9.27382 9.68657C9.27499 9.68657 9.27617 9.68657 9.27734 9.68676C9.28164 9.68696 9.28575 9.68735 9.28986 9.68774C9.29025 9.68774 9.29064 9.68774 9.29103 9.68774C9.36263 9.69517 9.42915 9.72667 9.48079 9.77832C9.4982 9.79573 9.51346 9.81509 9.52618 9.83563C9.55063 9.87515 9.56608 9.91956 9.57117 9.96631C9.57117 9.9669 9.57117 9.96749 9.57137 9.96807C9.57137 9.96847 9.57137 9.96886 9.57137 9.96925C9.57176 9.97355 9.57215 9.97786 9.57234 9.98196C9.57234 9.98314 9.57234 9.98412 9.57254 9.98529C9.57274 9.98959 9.57293 9.99409 9.57293 9.9984C9.57293 9.99937 9.57293 10.0004 9.57293 10.0011V10.0808V10.4215V10.8417C9.57293 10.9261 9.54007 11.0051 9.4806 11.0648C9.47688 11.0685 9.47297 11.0722 9.46886 11.0759L9.46964 11.0769Z"
          fill="white"
        />
        <path
          d="M7.83978 17.5885V20.4868C7.83978 20.4958 7.83796 20.5051 7.83796 20.5141C7.83796 20.5542 7.83796 20.5961 7.83615 20.6362C7.83416 20.6471 7.83416 20.6564 7.83235 20.6673C7.83053 20.7073 7.82872 20.7474 7.82327 20.7857V20.7966C7.82145 20.802 7.82145 20.8077 7.82145 20.8131C7.77225 21.2487 7.62994 21.6625 7.40012 22.0307C7.28157 22.2221 7.14107 22.4026 6.97878 22.5648C6.49718 23.0461 5.87707 23.3395 5.2094 23.4088C5.20577 23.4088 5.20214 23.4106 5.19851 23.4106C5.1602 23.4142 5.12008 23.416 5.08178 23.4196C5.07088 23.4196 5.05999 23.4215 5.04893 23.4215C5.01062 23.4233 4.9705 23.4233 4.9322 23.4253H4.89753C3.2779 23.4253 1.95908 22.1073 1.95908 20.4868V16.606C1.7745 16.4672 1.59999 16.3156 1.43736 16.1521C0.609219 15.3245 0.0747903 14.2017 0.0074295 12.9567V12.9422C0.0056134 12.913 0.0056134 12.882 0.0036322 12.8509C0.0036322 12.8401 0.0036322 12.8273 0.0018161 12.8163V12.7434C0.0018161 12.7252 0 12.7087 0 12.6924V20.4868C0 21.5896 0.364871 22.6067 0.981355 23.4253C1.87702 24.6137 3.29787 25.3829 4.89753 25.3847H4.89935C4.91586 25.3847 4.9322 25.3829 4.95053 25.3829H5.0235C5.0344 25.3811 5.04711 25.3811 5.05801 25.3811C5.08905 25.3792 5.12008 25.3792 5.14931 25.3774H5.16384C6.40968 25.3099 7.53335 24.7759 8.36133 23.9483C8.66957 23.642 8.93588 23.2939 9.15298 22.9148C9.15298 22.9166 9.1548 22.9166 9.1548 22.9166C9.48318 22.3442 9.69105 21.7135 9.76584 21.05C9.7769 20.9515 9.78598 20.8514 9.79143 20.7511C9.79143 20.7456 9.79143 20.742 9.79324 20.7384C9.79324 20.7073 9.79506 20.6745 9.79688 20.6435V20.6125C9.79869 20.5834 9.79869 20.5542 9.79869 20.5268V17.5885H7.83978Z"
          fill="white"
        />
        <path
          d="M16.3797 9.41512L16.3779 9.4133C16.3525 9.38592 16.3287 9.35853 16.3031 9.33312C16.2995 9.32932 16.2959 9.32388 16.2922 9.32025C16.263 9.28923 16.2338 9.26019 16.2047 9.23099C16.1737 9.19997 16.1445 9.17077 16.1153 9.14354C16.1098 9.13793 16.1062 9.1343 16.1007 9.13067C16.0751 9.10527 16.0479 9.08151 16.0223 9.05775C16.0211 9.05654 16.0199 9.05533 16.0187 9.05412C15.8965 8.94473 15.7705 8.84095 15.6411 8.74608C15.2871 8.48539 14.9041 8.27585 14.4993 8.12093C13.9465 7.90759 13.352 7.79639 12.7391 7.79639H4.90116C3.79763 7.79639 2.77996 8.16102 1.96089 8.7771C0.771678 9.67218 0.0018161 11.0921 0 12.6907V12.6925C0 12.7088 0.0018161 12.7253 0.0018161 12.7435V12.8164C0.0036322 12.8275 0.0036322 12.8402 0.0036322 12.8511C0.0056134 12.8821 0.0056134 12.9131 0.0074295 12.9423V12.9568C0.0747903 14.2019 0.609219 15.3246 1.43736 16.1522C1.59999 16.3157 1.7745 16.4674 1.95908 16.6061C2.12236 16.7289 2.29357 16.8416 2.47155 16.9434C2.46973 16.9434 2.46973 16.9452 2.46973 16.9452C3.04246 17.2733 3.67364 17.4811 4.33751 17.5558C4.43607 17.5667 4.53646 17.5759 4.63667 17.5814C4.64212 17.5814 4.64592 17.5814 4.64955 17.5832C4.68059 17.5832 4.71328 17.585 4.74432 17.5868H4.77535C4.80458 17.5886 4.8338 17.5886 4.86104 17.5886H12.7391C12.8225 17.5886 12.9055 17.5867 12.9881 17.5825C13.0069 17.5815 13.0257 17.5806 13.0444 17.5794C13.0647 17.5781 13.085 17.5768 13.1052 17.5753C13.1253 17.5738 13.1454 17.5721 13.1656 17.5705C13.1847 17.5688 13.2037 17.5672 13.2227 17.5654C13.2248 17.565 13.2268 17.5649 13.229 17.5647C13.2481 17.5627 13.2671 17.5608 13.2863 17.5588C13.3262 17.5543 13.3663 17.5494 13.4061 17.5441C13.6676 17.5086 13.9242 17.4527 14.1738 17.3768C14.1905 17.3717 14.2072 17.3666 14.2237 17.3613C14.2427 17.3552 14.2617 17.3491 14.2805 17.343C14.3153 17.3314 14.35 17.3195 14.3847 17.3072C14.4236 17.2935 14.4624 17.2791 14.5011 17.2641C14.5184 17.2575 14.5357 17.2507 14.5529 17.2438C14.5688 17.2375 14.5844 17.2313 14.6001 17.2248C14.6361 17.2101 14.672 17.195 14.7074 17.1793C14.7243 17.1719 14.7411 17.1644 14.758 17.1569C14.773 17.1501 14.7882 17.1432 14.8032 17.1361C14.8158 17.1305 14.8281 17.1245 14.8405 17.1186C14.856 17.1113 14.8716 17.1039 14.8869 17.0963C14.9049 17.0876 14.9226 17.0788 14.9404 17.0697C14.9581 17.0608 14.9759 17.0518 14.9934 17.0427C15.034 17.0216 15.0743 16.9999 15.1144 16.9777C15.5012 16.7629 15.8612 16.4938 16.1846 16.174C16.1914 16.1674 16.198 16.1608 16.2047 16.154C16.2338 16.1248 16.263 16.0958 16.2922 16.0648C16.2959 16.0611 16.2995 16.0557 16.3031 16.0519C16.316 16.0374 16.3287 16.0247 16.3414 16.01C16.5146 15.8183 16.6703 15.615 16.8092 15.4022C16.8108 15.3997 16.8125 15.3971 16.8141 15.3946C16.8296 15.3707 16.845 15.3467 16.86 15.3226C16.8747 15.2994 16.8891 15.2759 16.9033 15.2525C16.9112 15.2392 16.9191 15.2258 16.9269 15.2124C16.9457 15.1806 16.9644 15.1486 16.9824 15.1164C16.983 15.1151 16.9837 15.1139 16.9843 15.1126C16.9908 15.1011 16.9972 15.0893 17.0035 15.0778C17.0111 15.0641 17.0185 15.0504 17.0259 15.0365C17.052 14.988 17.0771 14.939 17.1012 14.8899C17.1064 14.8795 17.1115 14.8692 17.1164 14.8589C17.1192 14.8529 17.1222 14.8468 17.125 14.8409C17.1318 14.827 17.1384 14.813 17.1448 14.799C17.1527 14.7821 17.1603 14.7653 17.1681 14.7483C17.1757 14.7315 17.1833 14.7145 17.1907 14.6975C17.1981 14.6805 17.2056 14.6635 17.2128 14.6463C17.2199 14.6293 17.2272 14.6122 17.2343 14.595C17.2483 14.5607 17.262 14.5264 17.2754 14.4917C17.2888 14.4571 17.3017 14.4224 17.3142 14.3875C17.3173 14.3791 17.3203 14.3705 17.3233 14.3619C17.3274 14.3505 17.3314 14.3391 17.3352 14.3277C17.3416 14.3089 17.3481 14.2901 17.3543 14.2713C17.3601 14.2533 17.3661 14.2353 17.3718 14.2172C17.3725 14.2152 17.3732 14.2131 17.3738 14.2109C17.4446 13.987 17.4993 13.7572 17.5369 13.5229V13.5226C17.5445 13.4757 17.5515 13.4289 17.5576 13.3817C17.57 13.2873 17.5797 13.1923 17.5866 13.0966C17.5881 13.0764 17.5894 13.0562 17.5908 13.036C17.5932 12.9979 17.595 12.9598 17.5964 12.9215C17.5988 12.8588 17.6 12.7958 17.6 12.7326V12.0764C17.476 11.0848 17.0547 10.1624 16.3797 9.41512ZM15.0228 14.5445C15.021 14.5445 15.021 14.5464 15.019 14.5464C14.9917 14.581 14.9643 14.6138 14.9351 14.6447C14.9315 14.6503 14.926 14.6557 14.9224 14.6612C14.8877 14.6977 14.8531 14.7341 14.8184 14.7706L14.8111 14.7778C14.8073 14.7816 14.8037 14.7854 14.8002 14.7894C14.7935 14.7965 14.7872 14.8036 14.7801 14.8107C14.7436 14.8453 14.7071 14.88 14.6706 14.9126C14.6652 14.9182 14.6597 14.9219 14.6543 14.9273C14.6232 14.9565 14.5904 14.9837 14.5575 15.0111C14.5557 15.0111 14.5539 15.013 14.5539 15.0148C13.8882 15.5543 13.0399 15.7604 12.2338 15.6308H4.90116C4.89208 15.6308 4.883 15.629 4.87392 15.629C4.8338 15.629 4.7917 15.629 4.75158 15.6272C4.74068 15.6254 4.7316 15.6254 4.72071 15.6236C4.68059 15.6218 4.6403 15.62 4.602 15.6145H4.5911C4.58566 15.6127 4.58021 15.6127 4.57476 15.6127C4.13873 15.5635 3.72466 15.4213 3.35632 15.1916C3.1648 15.0732 2.98418 14.9328 2.82189 14.7706C2.34029 14.2893 2.04658 13.6696 1.97724 13.0024C1.97724 12.9987 1.97542 12.9951 1.97542 12.9915C1.97179 12.9532 1.96997 12.9131 1.96634 12.8748C1.96634 12.8639 1.96453 12.8529 1.96453 12.842C1.96271 12.8037 1.96271 12.7636 1.96089 12.7253V12.6907C1.96089 11.072 3.27971 9.75418 4.90116 9.75418H12.7391C13.423 9.75418 14.0707 9.98566 14.5922 10.4103C14.594 10.4122 14.594 10.414 14.5958 10.414C14.6287 10.4414 14.6615 10.4686 14.6944 10.4978C14.698 10.5032 14.7053 10.507 14.7089 10.5125C14.7472 10.5451 14.7819 10.5798 14.8184 10.6144C14.8531 10.6509 14.8877 10.6874 14.9224 10.7238C14.926 10.7293 14.9315 10.7349 14.9351 10.7403C14.9643 10.7712 14.9917 10.804 15.019 10.8369C15.021 10.8387 15.021 10.8405 15.0228 10.8405C15.3565 11.2507 15.5627 11.7319 15.6411 12.2295C15.7687 13.0334 15.5627 13.8791 15.0228 14.5445Z"
          fill="white"
        />
        <path
          d="M17.598 4.77222V4.7412C17.5962 4.71018 17.5943 4.67735 17.5943 4.64633C17.5925 4.6427 17.5925 4.63907 17.5925 4.63362C17.5871 4.53331 17.578 4.43316 17.5671 4.33466C17.4923 3.67123 17.2843 3.04047 16.9559 2.46811C16.9559 2.46811 16.9541 2.46811 16.9541 2.46992C16.7371 2.09077 16.4708 1.74264 16.1626 1.43642C15.3345 0.608819 14.2108 0.0747412 12.9651 0.00725963H12.9504C12.9212 0.00544472 12.8903 0.00544472 12.8593 0.00362982C12.8482 0.00362982 12.8355 0.00362982 12.8246 0.00181491H12.7516C12.7333 0.00181491 12.717 0 12.7006 0H12.6986C11.099 0.00181491 9.67813 0.771006 8.78246 1.95944C8.16598 2.77796 7.80127 3.79514 7.80127 4.89794V12.7306C7.80127 12.9388 7.81415 13.1449 7.83957 13.348C7.88877 13.7423 7.98503 14.1251 8.12586 14.4896C8.28089 14.8943 8.49073 15.2771 8.75159 15.6306C8.84635 15.7602 8.95037 15.8859 9.05983 16.008C9.06104 16.0092 9.06225 16.0104 9.06346 16.0116C9.08707 16.0372 9.11084 16.0646 9.13643 16.09C9.14007 16.0956 9.1437 16.0992 9.14915 16.1047C9.17655 16.1339 9.20578 16.1629 9.23665 16.1939C9.26587 16.2231 9.2951 16.2523 9.32613 16.2814C9.32977 16.2852 9.33521 16.2888 9.33885 16.2924C9.36444 16.3178 9.39168 16.3416 9.41909 16.3672L9.4209 16.369C9.54225 16.4785 9.66822 16.5813 9.79849 16.6772C10.4703 17.1722 11.2527 17.4847 12.084 17.5884H12.7389C12.8223 17.5884 12.9053 17.5865 12.9879 17.5823C13.0067 17.5813 13.0255 17.5803 13.0442 17.5792C13.0645 17.5779 13.0848 17.5766 13.1049 17.5751C13.1251 17.5736 13.1452 17.5719 13.1654 17.5703C13.1845 17.5686 13.2035 17.567 13.2225 17.5652C13.2246 17.5648 13.2266 17.5647 13.2288 17.5645C13.2479 17.5625 13.2669 17.5606 13.2861 17.5586C13.3262 17.5543 13.3661 17.5493 13.4059 17.5439C13.6676 17.5087 13.9242 17.4528 14.1736 17.3766C14.1903 17.3715 14.207 17.3664 14.2235 17.3611C14.2425 17.355 14.2615 17.3489 14.2803 17.3428C14.3151 17.3312 14.3498 17.3193 14.3845 17.307C14.4234 17.2933 14.4622 17.2789 14.5009 17.2639C14.5182 17.2573 14.5355 17.2505 14.5527 17.2436C14.5686 17.2373 14.5842 17.2311 14.5999 17.2246C14.6359 17.2099 14.6717 17.1948 14.7072 17.1791C14.7241 17.1717 14.7409 17.1642 14.7578 17.1567C14.7728 17.1499 14.788 17.143 14.803 17.1359C14.8155 17.1303 14.8279 17.1243 14.8403 17.1184C14.8558 17.1111 14.8714 17.1037 14.8867 17.0961C14.9047 17.0874 14.9224 17.0786 14.9402 17.0695C14.9579 17.0606 14.9757 17.0516 14.9932 17.0425C15.0338 17.0214 15.0741 16.9997 15.1142 16.9775C15.1459 16.9598 15.1773 16.9418 15.2086 16.9235C15.2243 16.9143 15.2402 16.905 15.2559 16.8956C15.264 16.8909 15.272 16.8857 15.2803 16.8808C15.5415 16.7224 15.7895 16.5389 16.0203 16.3307C16.0348 16.3178 16.0477 16.3051 16.0622 16.2924C16.0658 16.2888 16.0713 16.2852 16.0749 16.2814C16.106 16.2523 16.1352 16.2231 16.1644 16.1939C16.1712 16.1872 16.1778 16.1806 16.1844 16.1738C16.5011 15.8537 16.7682 15.4983 16.9822 15.1162C16.9828 15.1149 16.9835 15.1137 16.9841 15.1124C16.9906 15.1009 16.997 15.0891 17.0033 15.0776C17.0109 15.0639 17.0183 15.0502 17.0257 15.0363C17.0518 14.9878 17.0769 14.9388 17.101 14.8897C17.1061 14.8793 17.1113 14.869 17.1162 14.8586C17.119 14.8527 17.122 14.8466 17.1248 14.8407C17.1316 14.8268 17.1382 14.8128 17.1446 14.7988C17.1525 14.7819 17.1601 14.7651 17.1679 14.7481C17.1755 14.7313 17.1831 14.7143 17.1905 14.6973C17.1979 14.6803 17.2054 14.6633 17.2126 14.6461C17.2197 14.6291 17.227 14.612 17.2341 14.5948C17.2481 14.5605 17.262 14.526 17.2752 14.4915C17.2886 14.4567 17.3016 14.4221 17.314 14.3873C17.3171 14.3789 17.3201 14.3703 17.3231 14.3617C17.3272 14.3503 17.3312 14.3389 17.335 14.3275C17.3414 14.3087 17.3479 14.2899 17.3541 14.2711C17.3599 14.2531 17.3658 14.2351 17.3716 14.217C17.3723 14.215 17.3729 14.2129 17.3736 14.2107C17.4443 13.9867 17.4988 13.7568 17.5367 13.5227V13.5224C17.5442 13.4755 17.5511 13.4287 17.5574 13.3815C17.5697 13.2871 17.5795 13.1921 17.5864 13.0964C17.5879 13.0762 17.5892 13.056 17.5905 13.0358C17.5929 12.9977 17.5947 12.9596 17.5962 12.9213C17.5986 12.8586 17.5998 12.7956 17.5998 12.7324V4.85785C17.5998 4.83046 17.5998 4.80126 17.598 4.77222ZM15.0244 14.5443C15.0226 14.5443 15.0208 14.5462 15.0208 14.548C14.9934 14.5808 14.966 14.6136 14.9367 14.6445C14.9313 14.6499 14.9276 14.6555 14.9222 14.661C14.8893 14.6975 14.8547 14.7339 14.82 14.7704C14.8134 14.777 14.8066 14.7829 14.8 14.7892C14.7957 14.793 14.7914 14.7969 14.7871 14.8012L14.7799 14.8087C14.7434 14.8433 14.7069 14.8778 14.6704 14.9124C14.665 14.9162 14.6595 14.9217 14.6541 14.9253C14.623 14.9545 14.5902 14.9817 14.5555 15.0091C14.5555 15.0109 14.5537 15.0109 14.5537 15.0127C13.888 15.5523 13.0417 15.7583 12.2372 15.6306C11.7392 15.5523 11.2578 15.3464 10.8474 15.0127C10.8474 15.0109 10.8455 15.0109 10.8437 15.0091C10.8109 14.9817 10.778 14.9545 10.747 14.9253C10.7415 14.9217 10.7361 14.9162 10.7306 14.9124C10.6942 14.8778 10.6577 14.8433 10.6212 14.8087C10.5865 14.7722 10.5518 14.7375 10.519 14.6993C10.5135 14.6956 10.5099 14.6884 10.5045 14.6846C10.4752 14.6519 10.4478 14.6191 10.4206 14.5862C10.4206 14.5844 10.4188 14.5844 10.4168 14.5826C10.0922 14.1845 9.88054 13.7131 9.79849 13.2081C9.77306 13.0518 9.76018 12.8923 9.76018 12.7306V4.89794C9.76018 3.27739 11.079 1.95944 12.6986 1.95944H12.7333C12.7716 1.96142 12.8117 1.96142 12.85 1.96324C12.8611 1.96324 12.872 1.96505 12.8829 1.96505C12.9212 1.96868 12.9613 1.97049 12.9996 1.97412C13.0032 1.97412 13.007 1.97594 13.0107 1.97594C13.6782 2.04524 14.2985 2.33859 14.7799 2.81987C14.9422 2.98206 15.0827 3.16256 15.2012 3.35395C15.431 3.72221 15.5734 4.13601 15.6226 4.57159C15.6226 4.57703 15.6226 4.58264 15.6244 4.58809V4.59898C15.63 4.63725 15.6318 4.67735 15.6336 4.71744C15.6354 4.72833 15.6354 4.73757 15.6372 4.74846C15.6391 4.78855 15.6391 4.83046 15.6391 4.87055C15.6391 4.87963 15.6409 4.88887 15.6409 4.89794V12.2257C15.7703 13.0314 15.5643 13.8789 15.0244 14.5443Z"
          fill="white"
        />
      </svg>
    </Link>
  );
}

function LogoFull() {
  return (
    <Link href="/" className="block mb-2 bg-[#ef0179] p-2 rounded-xl">
      <svg width="84" height="30" viewBox="0 0 370 132" fill="none">
        <path
          d="M114.435 75.1757C114.435 97.3642 130.662 113.26 152.851 113.26C175.15 113.26 191.377 97.3642 191.377 75.1757C191.377 52.9872 175.15 37.0909 152.851 37.0909C130.662 37.0909 114.435 52.9872 114.435 75.1757ZM175.26 75.1757C175.26 88.8641 166.429 99.3512 152.851 99.3512C139.273 99.3512 130.552 88.8641 130.552 75.1757C130.552 61.3769 139.273 51.0001 152.851 51.0001C166.429 51.0001 175.26 61.3769 175.26 75.1757Z"
          fill="white"
        />
        <path
          d="M213.306 105.092C217.611 110.611 223.462 113.26 229.754 113.26C243.443 113.26 253.378 102.994 253.378 85.2212C253.378 67.4483 243.443 57.2924 229.754 57.2924C223.241 57.2924 217.391 60.1626 213.306 65.3509V58.6171H199.287V132H213.306V105.092ZM238.806 85.2212C238.806 94.494 233.397 100.786 225.339 100.786C220.813 100.786 215.624 98.0265 213.306 94.7148V75.838C215.624 72.4159 220.813 69.7665 225.339 69.7665C233.397 69.7665 238.806 76.0588 238.806 85.2212Z"
          fill="white"
        />
        <path
          d="M281.744 113.26C287.595 113.26 291.348 111.715 293.445 109.838L290.465 99.2408C289.692 100.014 287.705 100.786 285.608 100.786C282.517 100.786 280.751 98.2473 280.751 94.9356V70.8704H291.569V58.6171H280.751V44.0455H266.62V58.6171H257.789V70.8704H266.62V98.6889C266.62 108.182 271.919 113.26 281.744 113.26Z"
          fill="white"
        />
        <path
          d="M296.524 104.981C302.154 110.169 311.096 113.26 320.369 113.26C335.161 113.26 343.44 105.975 343.44 96.1499C343.44 82.903 331.187 80.4744 322.024 78.7082C316.063 77.4939 311.869 76.2796 311.869 72.9679C311.869 69.8769 315.18 68.0003 320.258 68.0003C326.771 68.0003 332.843 70.76 336.044 74.1822L341.564 64.5782C336.375 60.3833 329.2 57.2924 320.148 57.2924C306.128 57.2924 298.29 65.1301 298.29 74.0718C298.29 86.7667 310.102 88.9745 319.265 90.7407C325.336 91.955 329.973 93.2797 329.973 97.033C329.973 100.345 327.102 102.442 321.031 102.442C314.408 102.442 306.459 98.7993 302.596 95.1564L296.524 104.981Z"
          fill="white"
        />
        <path
          d="M360.723 50.7794C365.36 50.7794 369.113 47.0261 369.113 42.3897C369.113 37.7533 365.36 34 360.723 34C356.197 34 352.334 37.7533 352.334 42.3897C352.334 47.0261 356.197 50.7794 360.723 50.7794ZM367.788 111.936V58.6171H353.769V111.936H367.788Z"
          fill="white"
        />
        <path
          d="M50.8428 91.322V106.579C50.8428 113.365 48.2022 119.753 43.4037 124.552C38.6053 129.35 32.2168 132 25.4214 132C18.6259 132 12.2469 129.359 7.44848 124.552C2.65003 119.753 0 113.365 0 106.579V65.9196C0 74.2104 4.00344 81.5831 10.1742 86.2302V106.579C10.1742 110.648 11.7548 114.481 14.6414 117.368C17.5186 120.245 21.3517 121.835 25.4214 121.835C29.4911 121.835 33.3242 120.245 36.2108 117.368C39.088 114.481 40.678 110.648 40.678 106.579V91.322H50.8428Z"
          fill="white"
        />
        <path
          d="M66.0996 40.4792H50.6348V50.6535H66.0996C70.1787 50.6535 74.0024 52.234 76.889 55.1207C77.0688 55.3005 77.2487 55.4898 77.419 55.6791C77.4474 55.7075 77.4663 55.7359 77.4947 55.7643C77.6462 55.9346 77.7881 56.0955 77.9301 56.2753H77.9396C79.6715 58.4143 80.741 60.9034 81.148 63.4777V45.4102C76.8133 42.2112 71.5889 40.4792 66.0996 40.4792Z"
          fill="white"
        />
        <path
          d="M62.6922 91.322H25.4214C19.7049 91.322 14.4237 89.4291 10.1742 86.2302C4.00344 81.5831 0 74.2104 0 65.9196V65.9006C0 65.8154 0 65.7303 0 65.6451V65.257C0 65.2003 0.0094644 65.134 0.0094644 65.0772C0.0094644 64.9163 0.0189288 64.7649 0.0283932 64.604V64.5283C0.378576 58.0641 3.14218 52.234 7.44848 47.9372C9.0385 46.3377 10.8462 44.9559 12.8053 43.8296C15.7677 42.1166 19.0518 41.0376 22.4874 40.6496C23.008 40.5928 23.5285 40.5455 24.049 40.5171H24.1153C24.2762 40.5171 24.4371 40.4982 24.6074 40.4982C24.6548 40.4887 24.7115 40.4887 24.7683 40.4887C24.9198 40.4887 25.0617 40.4887 25.2132 40.4792H40.4603V50.6535H25.2794C25.0617 50.6535 24.8535 50.6629 24.6358 50.6724C24.5885 50.6724 24.5317 50.6819 24.4844 50.6819C24.2762 50.6819 24.068 50.7103 23.8598 50.7292C23.8408 50.7292 23.8314 50.7292 23.8124 50.7387C23.784 50.7387 23.7556 50.7387 23.7272 50.7387C21.4653 50.9847 19.3168 51.723 17.3956 52.9155C16.4018 53.5307 15.4743 54.2594 14.632 55.1112C12.1334 57.6098 10.6096 60.8182 10.2499 64.2822C10.2405 64.3011 10.2405 64.3201 10.2405 64.339C10.2216 64.5472 10.2026 64.746 10.1932 64.9542C10.1932 65.011 10.1837 65.0583 10.1837 65.1151C10.1742 65.3233 10.1648 65.5221 10.1648 65.7208V65.9006C10.1648 74.305 17.0075 81.1478 25.4119 81.1478H45.3913C45.8834 81.8197 46.4229 82.4728 46.9907 83.1069L47.0097 83.1258C47.1327 83.2583 47.2557 83.4003 47.3882 83.5328C47.4072 83.5612 47.4261 83.5801 47.4545 83.6085C47.5965 83.7599 47.7479 83.9114 47.9088 84.0723C48.0602 84.2237 48.2117 84.3751 48.3725 84.5266C48.3915 84.5455 48.4199 84.5644 48.4388 84.5834C48.5713 84.7159 48.7133 84.8389 48.8552 84.9714C52.7356 88.4827 57.5246 90.669 62.6733 91.3125L62.6922 91.322Z"
          fill="white"
        />
        <path
          d="M81.148 63.4777V66.0994C81.148 70.1596 79.5674 73.9832 76.7186 76.8509C76.7754 76.7941 76.8322 76.7468 76.889 76.69C77.0688 76.5007 77.2486 76.3114 77.419 76.1222C77.4474 76.0938 77.4663 76.0654 77.4947 76.037C77.6461 75.8761 77.7881 75.7057 77.9301 75.5354C77.9301 75.5354 77.9395 75.5164 77.949 75.5164C80.7505 72.0619 81.8199 67.661 81.148 63.4777ZM75.2327 89.6373C72.365 90.7447 69.2796 91.322 66.0996 91.322H62.6924C63.7429 91.4545 64.8124 91.5207 65.8914 91.5207C72.242 91.5207 78.2329 89.2114 82.9083 84.9903H82.9178C82.9841 84.9146 83.0503 84.8578 83.1166 84.7915C80.7789 86.9021 78.1099 88.53 75.2327 89.6373Z"
          fill="white"
        />
        <path
          d="M91.303 24.7778V24.6169C91.2936 24.456 91.2841 24.2856 91.2841 24.1248C91.2841 24.1058 91.2841 24.0869 91.2841 24.0585C91.2557 23.538 91.2084 23.0174 91.1516 22.5063C90.7635 19.0613 89.6846 15.7866 87.981 12.8148C87.981 12.8148 87.981 12.8148 87.981 12.8243C86.8548 10.8557 85.473 9.04797 83.8735 7.45795C79.5577 3.16111 73.7276 0.38804 67.2634 0.0378576H67.1877C67.0363 0.0283932 66.8754 0.0283932 66.7145 0.0189288C66.6577 0.0189288 66.5915 0.0189288 66.5347 0.0094644H66.1561C66.0615 0.0094644 65.9763 0 65.8911 0H65.8816C57.5814 0.0094644 50.2086 4.00344 45.5616 10.1742C42.3626 14.4237 40.4697 19.7049 40.4697 25.4308V66.0994C40.4697 69.2794 41.0471 72.3648 42.1544 75.2325C42.9589 77.3336 44.0473 79.3211 45.4007 81.1572C45.8928 81.8292 46.4323 82.4822 47.0002 83.1164L47.0191 83.1353C47.1421 83.2678 47.2652 83.4097 47.3977 83.5423C47.4166 83.5706 47.4355 83.5896 47.4639 83.618C47.6059 83.7694 47.7573 83.9208 47.9182 84.0817C48.0696 84.2331 48.2211 84.3846 48.382 84.536C48.4009 84.5549 48.4293 84.5739 48.4482 84.5928C48.5807 84.7253 48.7227 84.8483 48.8647 84.9808C52.7451 88.4921 57.534 90.6784 62.6827 91.322H66.0899C69.2699 91.322 72.3553 90.7447 75.223 89.6373C78.1002 88.53 80.7691 86.9021 83.1068 84.7915C83.1826 84.7253 83.2488 84.659 83.3245 84.5928C83.3435 84.5739 83.3719 84.5549 83.3908 84.536C83.5517 84.3846 83.7031 84.2331 83.8545 84.0817C88.6624 79.2738 91.303 72.8948 91.303 66.0994V25.2226C91.303 25.0807 91.303 24.9292 91.2936 24.7778H91.303ZM77.9488 75.5164C77.9488 75.5164 77.9298 75.5259 77.9298 75.5354C77.7879 75.7057 77.6459 75.8761 77.4945 76.037C77.4661 76.0654 77.4471 76.0938 77.4187 76.1222C77.2484 76.3115 77.0686 76.5007 76.8887 76.69C76.832 76.7468 76.7752 76.7941 76.7184 76.8509L76.6805 76.8888C76.4912 77.0686 76.3019 77.2484 76.1127 77.4282C76.0843 77.4472 76.0559 77.4756 76.0275 77.4945C75.8666 77.6459 75.6962 77.7879 75.5164 77.9299C75.5164 77.9393 75.5069 77.9393 75.5069 77.9488C72.0524 80.7503 67.6609 81.8197 63.4872 81.1572C60.9034 80.7503 58.4048 79.6808 56.2753 77.9488C56.2753 77.9393 56.2658 77.9393 56.2563 77.9299C56.086 77.7879 55.9156 77.6459 55.7547 77.4945C55.7263 77.4756 55.6979 77.4472 55.6696 77.4282C55.4803 77.2484 55.291 77.0686 55.1017 76.8888C54.9219 76.6995 54.742 76.5197 54.5717 76.3209C54.5433 76.302 54.5244 76.2641 54.496 76.2452C54.3445 76.0748 54.2026 75.9045 54.0606 75.7341C54.0606 75.7247 54.0511 75.7247 54.0417 75.7152C51.8365 73.0084 50.6345 69.6485 50.6345 66.0994V25.4308C50.6345 17.017 57.4773 10.1742 65.8816 10.1742H66.0615C66.2602 10.1837 66.4684 10.1837 66.6672 10.1932C66.724 10.1932 66.7808 10.2026 66.8375 10.2026C67.0363 10.2216 67.2445 10.231 67.4433 10.2499C67.4622 10.2499 67.4811 10.2594 67.5001 10.2594C70.964 10.6191 74.1819 12.1428 76.6805 14.6414C77.5229 15.4838 78.2516 16.4207 78.8668 17.4145C80.0593 19.3263 80.7975 21.4747 81.0531 23.7367C81.0531 23.7651 81.0531 23.7935 81.0625 23.8219V23.8787C81.0909 24.0774 81.1004 24.2856 81.1099 24.4939C81.1193 24.5507 81.1193 24.598 81.1288 24.6548C81.1383 24.863 81.1383 25.0807 81.1383 25.2889C81.1383 25.3362 81.1477 25.3835 81.1477 25.4308V63.4777C81.8197 67.661 80.7502 72.0619 77.9488 75.5164Z"
          fill="white"
        />
      </svg>
    </Link>
  );
}

function SidebarLinkGroup({ children, activecondition }) {
  const [open, setOpen] = useState(activecondition);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <li className="p-2 rounded-sm mb-0.5 last:mb-0">
      {children(handleClick, open)}
    </li>
  );
}

function getListClass(matches) {
  return classNames("p-2 rounded-lg mb-0.5 last:mb-0", {
    "bg-purple-100": matches,
  });
}

function getLinkClass(matches) {
  return classNames("block", {
    "text-purple-800 hover:text-purple-600": matches,
    "text-slate-500 hover:text-purple-800": !matches,
  });
}

function getIconClass(matches) {
  return classNames("h-4 w-4", {
    "text-purple-800": matches,
    "text-slate-400 hover:text-slate-200": !matches,
  });
}

export default Sidebar;

function DashboardListItem({ pathname }) {
  const listClass = getListClass(pathname === "/");
  const linkClass = getLinkClass(pathname === "/");
  const iconClass = getIconClass(pathname === "/");

  return (
    <li className={listClass}>
      <Link href="/" className={linkClass}>
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <FontAwesomeIcon
              icon={faHouse}
              fixedWidth={true}
              className={iconClass}
            />
            <span className="ml-2 pt-0.5 text-sm font-medium">Dashboard</span>
          </div>
        </div>
      </Link>
    </li>
  );
}

function StoreListItem({ pathname }) {
  const linkClass = getLinkClass(pathname.includes("/store"));
  const iconClass = getIconClass(pathname.includes("/store"));

  const subLinks = [
    { name: "Overview", href: "/store/overview" },
    { name: "Website Analytics", href: "/store/ga_shopping" },
  ];

  return (
    <SidebarLinkGroup activecondition={pathname.includes("store")}>
      {(handleClick, open) => {
        open = pathname.includes("store") ? true : open;

        const chevClass = classNames(
          "w-3 h-3 shrink-0 ml-1 fill-current text-slate-400",
          {
            "rotate-180": open,
          }
        );

        return (
          <React.Fragment>
            <a
              href="#0"
              className={linkClass}
              onClick={(e) => {
                e.preventDefault();
                handleClick();
              }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FontAwesomeIcon
                    icon={faStore}
                    fixedWidth={true}
                    className={iconClass}
                  />
                  <span className="text-sm ml-2 pt-0.5">Store</span>
                </div>
                {/* Icon */}
                <div className="flex ml-2 shrink-0">
                  <svg className={chevClass} viewBox="0 0 12 12">
                    <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                  </svg>
                </div>
              </div>
            </a>
            <ul
              className={`pl-7 mt-1 flex flex-col gap-1 ${!open && "hidden"}`}
            >
              {subLinks.map((link, index) => {
                const linkClass = classNames("block leading-none", {
                  "text-purple-800 hover:text-purple-600":
                    pathname === link.href,
                  "text-slate-500 hover:text-purple-800":
                    pathname !== link.href,
                });

                return (
                  <li className="mb-1 last:mb-0" key={index}>
                    <Link href={link.href} className={linkClass}>
                      <span className="text-xs">{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        );
      }}
    </SidebarLinkGroup>
  );
}

function MarketingItem({ pathname }) {
  const linkClass = getLinkClass(pathname.includes("/marketing"));
  const iconClass = getIconClass(pathname.includes("/marketing"));

  const subLinks = [
    { name: "Meta", href: "/marketing/facebook" },
    { name: "Google Ads", href: "/marketing/google_ads" },
    { name: "Klaviyo", href: "/marketing/klaviyo" },
    { name: "Optimiser", href: "/marketing/optimiser" },
  ];

  return (
    <SidebarLinkGroup activecondition={pathname.includes("marketing")}>
      {(handleClick, open) => {
        open = pathname.includes("marketing") ? true : open;

        const chevClass = classNames(
          "w-3 h-3 shrink-0 ml-1 fill-current text-slate-400",
          {
            "rotate-180": open,
          }
        );

        return (
          <React.Fragment>
            <a
              href="#0"
              className={linkClass}
              onClick={(e) => {
                e.preventDefault();
                handleClick();
              }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FontAwesomeIcon
                    icon={faCommentDollar}
                    fixedWidth={true}
                    className={iconClass}
                  />
                  <span className="text-sm ml-2 pt-0.5">Marketing</span>
                </div>
                {/* Icon */}
                <div className="flex ml-2 shrink-0">
                  <svg className={chevClass} viewBox="0 0 12 12">
                    <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                  </svg>
                </div>
              </div>
            </a>
            <ul
              className={`pl-7 mt-1 flex flex-col gap-1 ${!open && "hidden"}`}
            >
              {subLinks.map((link, index) => {
                const linkClass = classNames("block leading-none", {
                  "text-purple-800 hover:text-purple-600":
                    pathname === link.href,
                  "text-slate-500 hover:text-purple-800":
                    pathname !== link.href,
                });

                return (
                  <li className="mb-1 last:mb-0" key={index}>
                    <Link href={link.href} className={linkClass}>
                      <span className="text-xs">{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        );
      }}
    </SidebarLinkGroup>
  );
}

function ProductItem({ pathname }) {
  const linkClass = getLinkClass(pathname.includes("/product"));
  const iconClass = getIconClass(pathname.includes("/product"));

  const subLinks = [
    // { name: "Performance", href: "/product/insights" },
    { name: "Inventory", href: "/product/inventory" },
    { name: "Trends", href: "/product/trends" },
    { name: "Line Inventory", href: "/product/line" },
  ];

  return (
    <SidebarLinkGroup activecondition={pathname.includes("product")}>
      {(handleClick, open) => {
        open = pathname.includes("product") ? true : open;

        const chevClass = classNames(
          "w-3 h-3 shrink-0 ml-1 fill-current text-slate-400",
          {
            "rotate-180": open,
          }
        );

        return (
          <React.Fragment>
            <a
              href="#0"
              className={linkClass}
              onClick={(e) => {
                e.preventDefault();
                handleClick();
              }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FontAwesomeIcon
                    icon={faBoxOpen}
                    fixedWidth={true}
                    className={iconClass}
                  />
                  <span className="text-sm ml-2 pt-0.5">Products</span>
                </div>
                {/* Icon */}
                <div className="flex ml-2 shrink-0">
                  <svg className={chevClass} viewBox="0 0 12 12">
                    <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                  </svg>
                </div>
              </div>
            </a>
            <ul
              className={`pl-7 mt-1 flex flex-col gap-1 ${!open && "hidden"}`}
            >
              {subLinks.map((link, index) => {
                const linkClass = classNames("block leading-none", {
                  "text-purple-800 hover:text-purple-600":
                    pathname === link.href,
                  "text-slate-500 hover:text-purple-800":
                    pathname !== link.href,
                });

                return (
                  <li className="mb-1 last:mb-0" key={index}>
                    <Link href={link.href} className={linkClass}>
                      <span className="text-xs">{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        );
      }}
    </SidebarLinkGroup>
  );
}

function ChannelItem({ pathname }) {
  const linkClass = getLinkClass(pathname.includes("/channels"));
  const iconClass = getIconClass(pathname.includes("/channels"));

  const subLinks = [{ name: "Summary", href: "/channels/ga_channel" }];

  return (
    <SidebarLinkGroup activecondition={pathname.includes("channels")}>
      {(handleClick, open) => {
        open = pathname.includes("channels") ? true : open;

        const chevClass = classNames(
          "w-3 h-3 shrink-0 ml-1 fill-current text-slate-400",
          {
            "rotate-180": open,
          }
        );

        return (
          <React.Fragment>
            <a
              href="#0"
              className={linkClass}
              onClick={(e) => {
                e.preventDefault();
                handleClick();
              }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FontAwesomeIcon
                    icon={faBullhorn}
                    fixedWidth={true}
                    className={iconClass}
                  />
                  <span className="text-sm ml-2 pt-0.5">Channels</span>
                </div>
                {/* Icon */}
                <div className="flex ml-2 shrink-0">
                  <svg className={chevClass} viewBox="0 0 12 12">
                    <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                  </svg>
                </div>
              </div>
            </a>
            <ul
              className={`pl-7 mt-1 flex flex-col gap-1 ${!open && "hidden"}`}
            >
              {subLinks.map((link, index) => {
                const linkClass = classNames("block leading-none", {
                  "text-purple-800 hover:text-purple-600":
                    pathname === link.href,
                  "text-slate-500 hover:text-purple-800":
                    pathname !== link.href,
                });

                return (
                  <li className="mb-1 last:mb-0" key={index}>
                    <Link href={link.href} className={linkClass}>
                      <span className="text-xs">{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        );
      }}
    </SidebarLinkGroup>
  );
}

function CustomerItem({ pathname }) {
  const linkClass = getLinkClass(pathname.includes("/customer"));
  const iconClass = getIconClass(pathname.includes("/customer"));

  const subLinks = [
    { name: "Customer 360", href: "/customer/360" },
    { name: "Cohorts", href: "/customer/cohorts" },
  ];

  return (
    <SidebarLinkGroup activecondition={pathname.includes("customer")}>
      {(handleClick, open) => {
        open = pathname.includes("customer") ? true : open;

        const chevClass = classNames(
          "w-3 h-3 shrink-0 ml-1 fill-current text-slate-400",
          {
            "rotate-180": open,
          }
        );

        return (
          <React.Fragment>
            <a
              href="#0"
              className={linkClass}
              onClick={(e) => {
                e.preventDefault();
                handleClick();
              }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FontAwesomeIcon
                    icon={faUsers}
                    fixedWidth={true}
                    className={iconClass}
                  />
                  <span className="text-sm ml-2 pt-0.5">Customer Center</span>
                </div>
                {/* Icon */}
                <div className="flex ml-2 shrink-0">
                  <svg className={chevClass} viewBox="0 0 12 12">
                    <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                  </svg>
                </div>
              </div>
            </a>
            <ul
              className={`pl-7 mt-1 flex flex-col gap-1 ${!open && "hidden"}`}
            >
              {subLinks.map((link, index) => {
                const linkClass = classNames("block leading-none", {
                  "text-purple-800 hover:text-purple-600":
                    pathname === link.href,
                  "text-slate-500 hover:text-purple-800":
                    pathname !== link.href,
                });

                return (
                  <li className="mb-1 last:mb-0" key={index}>
                    <Link href={link.href} className={linkClass}>
                      <span className="text-xs">{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        );
      }}
    </SidebarLinkGroup>
  );
}

function AttributionItem({ pathname }) {
  const linkClass = getLinkClass(pathname.includes("/attribution"));
  const iconClass = getIconClass(pathname.includes("/attribution"));

  const subLinks = [
    { name: "KPIs", href: "/attribution/kpis" },
    { name: "Comp", href: "/attribution/comp" },
    { name: "Daywise Pref", href: "/attribution/perf" },
    { name: "Media Correlation", href: "/attribution/correlation" },
  ];

  return (
    <SidebarLinkGroup activecondition={pathname.includes("attribution")}>
      {(handleClick, open) => {
        open = pathname.includes("attribution") ? true : open;

        const chevClass = classNames(
          "w-3 h-3 shrink-0 ml-1 fill-current text-slate-400",
          {
            "rotate-180": open,
          }
        );

        return (
          <React.Fragment>
            <a
              href="#0"
              className={linkClass}
              onClick={(e) => {
                e.preventDefault();
                handleClick();
              }}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <FontAwesomeIcon
                    icon={faMagnifyingGlassDollar}
                    fixedWidth={true}
                    className={iconClass}
                  />
                  <span className="text-sm ml-2 pt-0.5">Attribution</span>
                </div>
                {/* Icon */}
                <div className="flex ml-2 shrink-0">
                  <svg className={chevClass} viewBox="0 0 12 12">
                    <path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
                  </svg>
                </div>
              </div>
            </a>
            <ul
              className={`pl-7 mt-1 flex flex-col gap-1 ${!open && "hidden"}`}
            >
              {subLinks.map((link, index) => {
                const linkClass = classNames("block leading-none", {
                  "text-purple-800 hover:text-purple-600":
                    pathname === link.href,
                  "text-slate-500 hover:text-purple-800":
                    pathname !== link.href,
                });

                return (
                  <li className="mb-1 last:mb-0" key={index}>
                    <Link href={link.href} className={linkClass}>
                      <span className="text-xs">{link.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        );
      }}
    </SidebarLinkGroup>
  );
}
